/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Row, Col } from 'reactstrap';
import { _translate } from "../../../../services/core";
import Icon from "../../../common/icon";
export default (function (_ref) {
  var addTransport = _ref.addTransport,
    index = _ref.index,
    display = _ref.display;
  var dashedLine = function dashedLine(className) {
    return /*#__PURE__*/React.createElement("div", {
      className: "stop-line d-flex justify-content-center w-100 ".concat(className)
    }, /*#__PURE__*/React.createElement("div", {
      className: "inner"
    }));
  };
  return /*#__PURE__*/React.createElement(Row, {
    className: "w-90 mx-auto p-0 d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    className: "stop-add color-red-wever my-2 d-flex align-items-center justify-content-center flex-column"
  }, dashedLine(), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "my-1 d-flex align-items-center add-stop-btn",
    onClick: function onClick() {
      return addTransport(index);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "plus-circle"
  }), "\xA0\xA0 ", _translate('collectorapp_add_stop_between')), dashedLine()));
});